<template>
  <div>
    <van-row class="padding10 h-header" v-if="isWhite">
      <van-col span="12">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/logo_white.png" style="width:60%;">
      </van-col>
      <van-col span="12" class="text-right" @click="navShow">
        <span style="color:#fff;">菜单</span> <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/menu_rec.png" style="width:10%">
      </van-col>
    </van-row>
    <van-row class="padding10 h-header" v-if="isBlack">
      <van-col span="12">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/logo_black.png" style="width:60%;">
      </van-col>
      <van-col span="12" class="text-right" @click="navShow">
        <span style="color:grey;">菜单</span> <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/menu_grey.png" style="width:10%">
      </van-col>
    </van-row>
    <full-page :options="options" ref="fullpage">
      <div class="section transparent" style="background-color: transparent;">
        <div class="box1">
          <firstPage @moveSectionDown="moveSectionDown" :activeShow="activeShow" ref="firstPage"></firstPage>
        </div>
      </div>
      <div class="section">
        <div class="box2">
          <secondPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></secondPage>
        </div>
      </div>
      <div class="section">
        <div class="box3">
          <thirdPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></thirdPage>
        </div>
      </div>
      <div class="section">
        <div class="box4">
          <fourthPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></fourthPage>
        </div>
      </div>
      <div class="section">
        <fifthPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></fifthPage>
      </div>
      <div class="section">
        <sixthPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></sixthPage>
      </div>
      <div class="section">
        <seventhPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></seventhPage>
      </div>
      <div class="section">
        <eighthPage @moveSectionDown="moveSectionDown" :activeShow="activeShow"></eighthPage>
      </div>
    </full-page>
    <!--        导航弹出层-->
    <van-popup v-model="navModal" position="right" :style="{ width: '100%',height:'100%' }">
      <navModal @closeNavModal="closeNavModal"></navModal>
    </van-popup>
    <!--        底部下载栏-->
    <div class="h-footer" :style="{display:footerShow?'':'none'}">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/footer-logo.png" class="footer-logo">
      <div class="h-footer-l">
        <span class="footer-text" style="font-size:14px;font-weight:bold;">365跑腿APP</span>
        <span class="footer-text" style="font-size:12px;">全程1小时速达</span>
      </div>
      <div class="h-footer-r">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/X.png" @click="hideFooter"><span @click="this.$goToUserClient">马上下载</span>
      </div>
    </div>
  </div>
</template>

<script>
  import firstPage from '../components/firstPage';
  import secondPage from '../components/secondPage';
  import thirdPage from '../components/thirdPage';
  import fourthPage from '../components/fourthPage';
  import fifthPage from '../components/fifthPage';
  import sixthPage from '../components/sixthPage';
  import seventhPage from '../components/seventhPage';
  import eighthPage from '../components/eighthPage';
  import navModal from '../components/common/nav';
  export default {
    name: '',
    data () {
      return {
        footerShow:true,
        isWhite:true,
        isBlack:false,
        navModal:false,
        activeShow:1,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          onLeave: this.beforeLoad,
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          scrollBar: false,
          menu: "#menu",
          // navigation: true,
          // anchors: ['page1', 'page2', 'page3'],
          sectionsColor: [
            "#fbfbfd",
            "#fff",
            "#000",
            "#fec401",
            "#000",
            "#fbfbfd",
            "#000",
            "#fbfbfd"
          ]
        }
      }
    },
    components:{firstPage,secondPage,thirdPage,fourthPage,fifthPage,sixthPage,seventhPage,eighthPage,navModal},
    created(){
      console.log(this.$loginURL);
    },
    methods:{
      // 导航展示
      navShow(){
        this.navModal = true;
      },
      // 关闭导航模块
      closeNavModal(){
        this.navModal = false;
      },
      // 翻页方法
      moveSectionDown(){
        this.$refs.fullpage.api.moveSectionDown();
      },
      beforeLoad: function(origin, destination) {
        //origin:翻页前参数/destination翻页后参数
        setTimeout(()=>{
          this.screenMethod(destination.index)
        },500)
        setTimeout(()=>{
          this.activeShow = destination.index+1;
        },100)
      },
      // 翻页回调方法
      afterLoad: function(origin, destination) {
        //origin:翻页前参数/destination翻页后参数
        console.log(origin,destination);
        if(destination.index == 0){
          // console.log(this.$refs.firstPage.play(), '---------------')
        }
      },
      // 滚动屏数处理方法
      screenMethod(index){
        if(index===0||index===2||index===4||index===6){
          this.isWhite = true;
          this.isBlack = false;
        }
        if(index===1||index===3||index===5||index===7){
          this.isWhite = false;
          this.isBlack = true;
        }
      },
      // 关闭浮层
      hideFooter(){
        this.footerShow = false;
      }
    }
  }
</script>
<style>
.box1{
  height: 100%;
}
.transparent{
  background-color: transparent!important;
}
</style>
